var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tags)?_c('div',{staticClass:"tags flex flex-align flex-wrap"},[_vm._l((_vm.tags),function(tag){return [_c('div',{key:tag.id,staticClass:"tag",class:{active: _vm.activeId === tag.id},on:{"click":function($event){return _vm.$emit('tag-clicked',tag)}}},[_vm._v("\n            "+_vm._s(tag.title)+"\n        ")])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }